import { getAuthHeaders } from "modules/common";
import { createService } from "services/serviceFactory";

const beekeepingService = createService("beekeeping");

async function uploadBloomCalendar(
    uploadedFile: File | null,
    accessToken: string
) {
    const authHeaders = getAuthHeaders(accessToken);
    const formData = new FormData();
    if (uploadedFile) {
        formData.append("formFile", uploadedFile);
    }
    const response = await beekeepingService.post(
        "/phytoview/v1/beekeeping",
        formData,
        authHeaders
    );
    return response.data;
}

export {
    uploadBloomCalendar,
};
